<template>
  <div class="service">
    <div class="title">
      <p>ServiceItems</p>
      <h2>服务项目</h2>
    </div>
    <div class="list">
      <el-row :gutter="30">
        <el-col
          :xs="24"
          :sm="12"
          :md="4"
          :lg="4"
          :xl="4"
          :offset="item.offset"
          v-for="(item,index) in project"
          :key="index"
        >
          <div class="item" @mouseenter="enter(index)" @mouseleave="leave(index)">
            <div class="info" v-if="showIndex !== index">
              <img v-lazy="item.img" class="img">
              <div class="text">
                <h1>{{item.title}}</h1>
                <p>{{item.brief}}</p>
                <p>{{item.brief1}}</p>
              </div>
            </div>
            <div class="info info-show" v-else v-for="(citem,cindex) in item.content" :key="cindex">
              <p class="info-text">{{citem.p1}}</p>
              <p>{{citem.p2}}</p>
              <p>{{citem.p3}}</p>
              <p>{{citem.p4}}</p>
              <p>{{citem.p5}}</p>
              <p>{{citem.p6}}</p>
              <p>{{citem.p7}}</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
const project = [
  {
    img: require("@/assets/images/img1.1.png"),
    title: "高新技术企业认定",
    brief: "所得税减免",
    brief1:'资金扶持的基本条件',
    content: [
      {p1: "1.上海高新技术企业认证",
      p2: "2.上海高新技术企业培育入库",
      p3: "",
      p4: "",
      p5: "",
      p6: ""}
],
    offset: 2
  },
  {
    img: require("@/assets/images/img1.2.png"),
    title: "资金扶持项目",
    brief: "缓解企业资金压力",
    brief1:'享受政府财政补贴',
    content: [{
      p1: "1. 科技小巨人",
      p2: "2. 教育附加金",
      p3: "3. 创业补贴",
      p4: "4.产业升级发展专项资金",
      p5: "5. 服务业发展引导资金",
      p6: ""
    }],
    offset: 0
  },
  {
    img: require("@/assets/images/img1.3.png"),
    title: "知识产权服务",
    brief: "保护专业技术",
    brief1:'获得补贴资质',
    content: [{
      p1: "1.发明专利",
      p2: "2.实用新型专利",
      p3: "3.外观专利",
      p4: "4.软件著作权",
      p5: "5.作品書作权",
      p6: "6.集成电路布图设计",
      p7: "7.商标注册"
    }],
    offset: 0
  },
  {
    img: require("@/assets/images/img1.4.png"),
    title: "双软评估",
    brief: "享受税收优惠",
    brief1:'提升品牌形象',
    content: [{
      p1: "1.软件产品评估",
      p2: "2.软件企业评估",
      p3: "",
      p4: "",
      p5: "",
      p6: ""
    }],
    offset: 0
  },
  {
    img: require("@/assets/images/img1.3.png"),
    title: "资质认证",
    brief: "国家级资质",
    brief1:'提升企业管理能力',
    content: [{
      p1: "1.ISO资质认定",
      p2: "2.建筑资质认定",
      p3: "3.知识产权贯标",
      p4: "4.专利示范企业",
      p5: "5.知识产权优势企业",
      p6: ""
    }],
    offset: 0
  },
  {
    img: require("@/assets/images/img1.5.png"),
    title: "研发费用加计扣除",
    brief: "研发费用按175%",
    brief1:'加计扣除',
    content: "",
    offset: 2
  },
  {
    img: require("@/assets/images/img1.1.png"),
    title: "科技小巨人",
    brief: "提高企业核心竞争力",
    brief1:'享百万资金补贴',
    content: "",
    offset: 0
  },
  {
    img: require("@/assets/images/img1.3.png"),
    title: "专利试点示范企业",
    brief: "保护专业技术",
    brief1:'获得补贴资质',
    content: "",
    offset: 0
  },
  {
    img: require("@/assets/images/img1.6.png"),
    title: "专项资金扶持政策",
    brief: "缓解企业资金压力 ",
    brief1:'享受政策补贴',
    content: "",
    offset: 0
  },
  {
    img: require("@/assets/images/img1.1.png"),
    title: "高新技术成果转化",
    brief: "增值税减免",
    brief1:'缓解企业资金压力',
    content: "",
    offset: 0
  }
];

export default {
  name: "Service",
  data() {
    return {
      showIndex: "",
      project: project
    };
  },

  methods: {
    enter(index) {
      if(index>4){return}
      this.showIndex = index;
    },
    leave(index) {
      this.showIndex = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.service {
  width: 1000px;
  margin: 0 auto;
  padding: 30px 0;
  .title {
    text-align: center;
    p {
      color: #f7a527;
      text-transform: uppercase;
      letter-spacing: 2px;
      font-size: 12px;
      line-height: 20px;
    }
    h2 {
      color: #666666;
      letter-spacing: 10px;
      margin-top: 10px;
    }
  }
  .list {
    padding: 30px 20px 0;
    .el-row {
      .el-col {
        margin-bottom: 20px;
      }
      .info {
        display: flex;
        flex-direction: column;
        height: 160px;
        border: 1px solid #eeeeee;
        text-align: center;
        padding: 30px 10px 10px;
        cursor: pointer;
        .img {
          margin: 0 auto;
          width: 65px;
          height: 65px;
        }
        .text {
          padding-left: 0px;
          h1 {
            font-size: 14px;
            line-height: 30px;
            color: #333;
          }
          p {
            font-size: 12px;
            color: #666;
          }
        }
      }
      .info-show {
        color: #999;
        font-size: 14px;
        border-bottom: 1px solid #f7a527;
        text-align: left;
        .info-text {
          color: #424c77;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .service {
    width: 100%;
    padding: 30px 0 10px;
    .list {
      padding: 30px 10px 10px;
      .el-row {
        margin-left: 0px !important;margin-right:0 !important;
        .el-col{margin-bottom: 0px;

        margin:10px 0;}
        .el-col-offset-2 {
          margin: 10px 0;
        }
        .info {
          flex-direction: row;
          text-align: left;
          align-items: center;
          height: 80px;
          padding: 10px;
          .img {
            width: 66px;
            height: 66px;
            margin: 0;
          }
          .text {
            padding-left: 10px;
            h1 {
              font-size: 14px;
              line-height: 30px;
              color: #333;
            }
            p {
              font-size: 12px;
              color: #666;
            }
          }
        }
        .info-show {
          display: none;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/technology/service.vue